/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_TitleInputs */

const en_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

const fr_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

const de_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

const it_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

const ru_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

const es_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

const zh_cn2_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

const ja_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

const hi_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

const pt_pt2_explorer_info_priority_title = /** @type {(inputs: Explorer_Info_Priority_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Priority`)
};

/**
* | output |
* | --- |
* | "Set Priority" |
*
* @param {Explorer_Info_Priority_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_title = /** @type {((inputs?: Explorer_Info_Priority_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_priority_title(inputs)
	if (locale === "de") return de_explorer_info_priority_title(inputs)
	if (locale === "it") return it_explorer_info_priority_title(inputs)
	if (locale === "ru") return ru_explorer_info_priority_title(inputs)
	if (locale === "es") return es_explorer_info_priority_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_priority_title(inputs)
	if (locale === "ja") return ja_explorer_info_priority_title(inputs)
	if (locale === "hi") return hi_explorer_info_priority_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_priority_title(inputs)
	return en_explorer_info_priority_title(inputs)
});